import React, { useState, FormEvent } from 'react';
import { TextField, Button, Container, Box, Alert } from '@mui/material';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import Header from '../CabecalhoSemMenu'; // Importa o componente Header
import Copyright from '../DireitosReservados'; // Importa o componente Copyright
import { useNavigate } from 'react-router-dom';
import { apiServer } from '../../api';

const PasswordRecovery: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [cnpj, setCnpj] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!email || !cnpj) {
      setError('Por favor, preencha todos os campos.');
      return;
    }

    if (!captchaToken) {
      setError('Por favor, complete a verificação de segurança.');
      return;
    }

    try {
      apiServer<string>().post("/usuario/esqueceu-senha", "", {
        email,
        cnpj,
        captchaToken
      }).then((response) => {
        setSuccess('Um e-mail de recuperação foi enviado para o endereço informado.');
        navigate("/login");
      }).catch((response) => {
        setError('Não foi possível enviar o e-mail de recuperação. Verifique os dados e tente novamente.');
      });
    } catch (error) {
      setError('Erro ao conectar com o servidor.');
    }
  };

  return (
    <>
      <Header title="Recuperação de senha" />

      <Container maxWidth="sm">
        {/* Barra superior com o nome e ícone da empresa */}
        <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}
          <Box component="form" onSubmit={handleSubmit} mt={2}>
            <TextField
              fullWidth
              label="E-mail"
              variant="outlined"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
            />
            <TextField
              fullWidth
              label="CNPJ"
              variant="outlined"
              margin="normal"
              value={cnpj}
              onChange={(e) => setCnpj(e.target.value)}
            />

            {/* hCaptcha */}
            <Box mt={2} display="flex" justifyContent="center">
              <HCaptcha
                sitekey="ba3c2726-c016-4502-b8d4-23d04ba0418a" // Substitua pela sua chave do hCaptcha
                onVerify={(token) => setCaptchaToken(token)}
                onExpire={() => setCaptchaToken(null)}
              />
            </Box>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              disabled={!captchaToken} // Desabilita o botão até o hCaptcha ser validado
            >
              Recuperar Senha
            </Button>
          </Box>
        </Box>

        {/* Rodapé */}

      </Container>
      <Copyright />
    </>
  );
};

export default PasswordRecovery;